import {
  NOVIDADE_CREATE,
  NOVIDADE_DELETE,
  NOVIDADE_LOAD,
  NOVIDADE_UPDATE
} from "../actions/novidade";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {};

const getters = {};

const actions = {
  [NOVIDADE_DELETE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.novidades
        .remover(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [NOVIDADE_UPDATE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.novidades
        .atualiza(payload.idnovidade, payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [NOVIDADE_CREATE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.novidades
        .adiciona(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [NOVIDADE_LOAD]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.novidades
        .obter(payload)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
